import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_EIC_BASIC_Schema } from './M_EIC_BASIC_Schema';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

/** 인력 조회 GetEicBasicR1 (Global.urls.EquipIssuance.getEicBasicR1) */
export const useSearch2 = (options = {}) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_EIC_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.EquipIssuance.getEicBasicR1, params);
  }, options);
};

/** 보호구등록 조회 GetPpeBasic01R1 (Global.urls.EquipIssuance.getPpeBasic01R1) */
export const useSearch3 = (options = {}) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_EIC_BASIC_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.EquipIssuance.getPpeBasic01R1, params);
  }, options);
};

/** 근로자별 보호구 저장 SaveEicBasicU1 (Global.urls.EquipIssuance.saveEicBasicU1) */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_EIC_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.EquipIssuance.saveEicBasicU1, payload);
  }, options);
};
